'use client';

import React, { ReactNode } from 'react';
import { ConsentType } from './type';
import { useGlobalClientContext } from '../common/GlobalClientContext';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogBody,
  DialogFooter,
  DialogAction,
  DialogCancel
} from '@altus-ui/components_v2/v3/Dialog';

export default function ConsentDetailModal({
  title,
  children,
  consentType,
  isNoticeConsent,
  onSubmit,
  onCancel
}: {
  title: string;
  children: ReactNode;
  consentType: ConsentType;
  isNoticeConsent: boolean;
  onSubmit: (consentType: ConsentType) => void;
  onCancel: () => void;
}) {
  const {
    i18nHelper: { t }
  } = useGlobalClientContext();
  return (
    <Dialog
      open
      onOpenChange={(open) => {
        if (!open) onCancel();
      }}>
      <DialogContent size="md">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <div className="flex flex-col gap-3xl">{children}</div>
        </DialogBody>
        <DialogFooter>
          <DialogCancel className="font-body" onClick={onCancel}>
            {isNoticeConsent
              ? t('confirm.capitalize', {})
              : t('close.capitalize', {})}
          </DialogCancel>
          {!isNoticeConsent && (
            <DialogAction
              className="font-body"
              onClick={() => onSubmit(consentType)}>
              {t('agree.capitalize', {})}
            </DialogAction>
          )}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
